// timerSlice.js
import { createSlice,createAsyncThunk } from '@reduxjs/toolkit';
import { GET_WORKHISTORY_BY_USER_ID, UPDATE_LOGINWORKHISTORY,UPDATE_LOGINWORKHISTORY_BY_ADMIN } from '../Queries/Orders';
import { client } from '..';



export const fetchWorkHistoryAndStartTask = createAsyncThunk(
  'timer/fetchWorkHistoryAndStartTask', // action type
  async (userId, { rejectWithValue }) => {
    try {
      // Perform the GraphQL mutation
      const { data } = await client.mutate({
        mutation: GET_WORKHISTORY_BY_USER_ID,
        variables: { userId },
      });

      // Assuming data.getWorkHistoryID is the result of the mutation
      const taskData = data.getWorkHistoryID[0];
        const payload = {
        task: taskData.taskType,
        time: Number(taskData.startTime)
      };
      localStorage.setItem('task', taskData.taskType);
      localStorage.setItem('time', taskData.startTime);
      return payload;
    } catch (error) {
      console.error('Error fetching work history:', error);
      return rejectWithValue('Error fetching work history');
    }
  }
);

export const updateLoginWorkHistoryThunk = createAsyncThunk(
  'workHistory/updateLogin',
  async ({ id, endTime }, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_LOGINWORKHISTORY,
        variables: { id, endTime },
        fetchPolicy: 'no-cache',
      });

      return data?.updateLoginWorkHistory;
    } catch (error) {
      console.error('Error in updateLoginWorkHistoryThunk:', error);
      return rejectWithValue(error?.message || 'Failed to update login work history');
    }
  }
);

export const updateLoginWorkHistoryThunkByAdmin = createAsyncThunk(
  'workHistory/updateLoginByAdmin',
  async ({ id, endTime }, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_LOGINWORKHISTORY_BY_ADMIN,
        variables: { id, endTime },
        fetchPolicy: 'no-cache',
      });

      const updatedLoginHistory = data?.updateLoginWorkHistoryByAdmin;

      if (!updatedLoginHistory) {
        return rejectWithValue('No login work history record was updated.');
      }

      return updatedLoginHistory;
    } catch (error) {
      console.error('Error in updateLoginWorkHistoryThunk:', error);
      return rejectWithValue(
        error?.message || 'Failed to update login work history'
      );
    }
  }
);

const timerSlice = createSlice({
  name: 'timer',
  initialState: {
    task:localStorage.getItem('task') ||  'Available',
    loginTime:Number(localStorage.getItem('LoginTime') ?? 0),
    isRunning: true,
    time: localStorage.getItem("LoginTime") ? Number(localStorage.getItem("time") ?? 0) : 0,
    taskUpdate: false,
    requestId:localStorage.getItem('requestId') || '',
    department:localStorage.getItem('department') || '',
    breakTimeToday: Number(localStorage.getItem('breakTimeToday')) || 0,
    popupCount: Number(localStorage.getItem('popupCount')) || 1,
    LoginMessgae:"",
  },
  reducers: {
    startTimer(state) {
      state.isRunning = true;
    },
    stopTimer(state) {
      state.isRunning = false;
      state.taskUpdate = true;

    },
    Starttask(state, action) {
     const { department, task,time,requestId } = action.payload;
      if (task === '') {
        state.task = localStorage.getItem('task');
      }
      else if (task) {
        state.taskUpdate = false;
        state.task = task; 
        state.time = time ; 
        state.isRunning = true;
    
      }
      if (department === '') {
        state.department = '';
      } else if (department) {
        state.department = department;
      }
    
      if (requestId === '') {
        state.requestId = '';
      } else if (requestId) {
        state.requestId = requestId;
      }
    },
    Endtask(state) {
    
      state.taskUpdate = false;
    },
    incrementTimer(state) {
      state.time += 1;

      if (state.task === "Break") {
        state.breakTimeToday += 1;
        localStorage.setItem("breakTimeToday", state.breakTimeToday);
      }
    },
    UpdateLoginTime(state,action) {
      state.loginTime = action.payload;
    },
    LoginMessgae(state,action) {
      state.LoginMessgae = action.payload;
    },
    Updatetime(state,action) {
      state.time = action.payload;
    },
    Updatetask(state,action) {
      state.task = action.payload;
    },
    CloseTask(state, action) {
      state.taskUpdate = false; 
      state.isRunning = true;
    },
    resetDailyBreak(state) {  
      state.breakTimeToday = 0;
      localStorage.setItem("breakTimeToday", 0);
    },
    setPopupCount: (state, action) => {
      state.popupCount = action.payload;
      localStorage.setItem('popupCount', action.payload);
    },
    resetPopupCount: (state) => {
      state.popupCount = 1;
      localStorage.setItem('popupCount', 1);
    },
     resetTimer(state) {
      state.task = "Available";
      state.loginTime = 0;
      state.isRunning = false;
      state.time = 0;

      localStorage.removeItem("task");
      localStorage.removeItem("LoginTime");
      localStorage.removeItem("time");
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchWorkHistoryAndStartTask.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Handle the action payload returned by the async thunk
        const { task, time } = action.payload;
        state.task = task;
        state.time = time;
        state.isRunning = true;
        state.taskUpdate = false;
      })

  },
});

export const { startTimer, stopTimer, incrementTimer,Updatetask, Starttask, Endtask,UpdateLoginTime,LoginMessgae,Updatetime,CloseTask, resetDailyBreak, setPopupCount, resetPopupCount,resetTimer } = timerSlice.actions;

export default timerSlice.reducer;
